module.exports = __webpack_public_path__ + "img/calculus.f54f82dd.svg";